import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";
import theme from "../../index.scss";

const CurrentPatient = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { dark } = useContext(ThemeContext);
  return (
    <div className="d-flex justify-content-center">
      <h6
        className="pt-2 pb-2 pl-3 pr-3"
        style={{
          width: "75%",
          borderRadius: "20px",
          backgroundColor: dark ? theme.darkModePrimary : "#60afa6",
          color: dark ? theme.darkModeText : "white",
          textAlign: "center",
          overflowWrap: "break-word",
          cursor: "pointer",
        }}
        onClick={() => history.push("/patientControl")}
      >
        {t("currentpatient.label")}
      </h6>
    </div>
  );
};

export default CurrentPatient;